<template>
    <div class="people limit">
        <div class="wrapper limit">
            <div class="person" v-for="(person, index) in people" :key="index">
                <img :src="require(`@/assets/images/people/${person.image}.png`)" />
                <div class="info">
                    <div class="info-wrap">
                        <blockquote>{{ person.quote }}</blockquote>
                        <span>{{ person.name }}</span>
                        <span>{{ person.title }}</span>
                        <span v-if="person.phone">
                            <a :href="`tel:${person.phone}`">{{ person.phone }}</a>
                        </span>
                        <span v-if="person.email">
                            <a :href="`mailto:${person.email}`">{{ person.email }}</a>
                        </span>
                        <span>
                            <a :href="person.linkedin">Linkedin</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        people() {
            return [
                {
                    name: "Arthur Poker",
                    image: "ARTHUR",
                    title: "Directeur",
                    quote:
                        "Data is what you need to do analytics. Information is what you need to do business",
                    linkedin:
                        "https://www.linkedin.com/in/arthur-poker-6569264/",
                    phone: "0655786878",
                    email: "arthur@weetdingen.nl"
                },
                {
                    name: "Cyril de Vroom",
                    image: "CYRIL",
                    title: "Directeur Imagineering",
                    quote: "Durf te doen",
                    linkedin: "http://nl.linkedin.com/in/cyrildevroom"
                },
                {
                    name: "Klaas Nagel",
                    image: "KLAAS",
                    title: "Commercieel directeur",
                    quote: "Doe wat je wilt, maar doe het NU",
                    linkedin: "https://www.linkedin.com/in/klaas-nagel-361a4a3/"
                },
                {
                    name: "Twan van Lierop",
                    image: "TWAN",
                    title: "Art director",
                    quote: "Feeling first, facts later",
                    linkedin: "http://www.linkedin.com/in/twanvanlierop"
                },
                {
                    name: "Lex van Rossum",
                    image: "LEX",
                    title: "Manager Operations",
                    quote: "Kennis, strategie, uitvoering",
                    linkedin:
                        "https://www.linkedin.com/in/lex-van-rossum-22316a48/"
                },
                {
                    name: "Geert Boetszkes",
                    image: "GEERT",
                    title: "Creative coder",
                    quote: "Talk is cheap, show me the code",
                    linkedin:
                        "https://www.linkedin.com/in/geert-boetzkes-54321473/"
                },
                {
                    name: "Jesper van der Meer",
                    image: "JESPER",
                    title: "Senior New Media Designer",
                    quote: "I make it look good",
                    linkedin: "https://www.linkedin.com/in/jesper-van-der-meer/"
                },
                {
                    name: "Teun Steenbekkers",
                    image: "TEUN",
                    title: "Creative coder",
                    quote: "Many things seem impossible until they are done",
                    linkedin:
                        "https://www.linkedin.com/in/teun-steenbekkers-a5081384/"
                },
                {
                    name: "Mathijs de Vries",
                    image: "MATHIJS",
                    title: "Creative Coder",
                    quote: "Lever geen product maar een ervaring",
                    linkedin: ""
                },
                {
                    name: "Jarne Cooijmans",
                    image: "JARNE",
                    title: "Creative coder",
                    quote: "Everything starts with an idea",
                    linkedin: "https://www.linkedin.com/in/jarne/"
                }
            ];
        }
    },
    mounted() {},

    components: {}
};
</script>

<style scoped lang="scss">
.people {
    width: 100%;
    background-color: black;
    color: white;

    padding-top: 100px;
    padding: 20px;
    padding-bottom: 100px;
}

.wrapper {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
}

.person {
    max-width: 50%;
    display: grid;
    grid-template-columns: 1fr 1fr;

    @media screen and (max-width: 850px) {
        grid-template-columns: 1fr;
    }

    margin-bottom: 50px;

    &.single {
        grid-template-columns: 1fr;
        text-align: center;
        @media screen and (max-width: 850px) {
            text-align: left;
        }
    }

    &:nth-child(even) {
        img {
            order: 2;
        }

        .info {
            order: 1;
            text-align: right;
        }
    }

    img {
        width: 100%;
    }

    .info {
        display: flex;
        justify-content: center;
        align-items: center;

        @media screen and (max-width: 850px) {
            justify-content: unset;
        }

        width: 100%;
    }

    .info-wrap {
        display: flex;
        flex-direction: column;
        padding: 25px;

        blockquote {
            font-size: 30px;
            margin-bottom: 25px;
        }

        a {
            color: white;
        }

        span {
            margin-bottom: 10px;

            &:first {
                font-weight: bold;
            }
        }
    }
}
</style>
